// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  DashboardOutlined,
  FileOutlined,
  AreaChartOutlined,
  ProfileOutlined,
} from '@ant-design/icons';

import ScheduleIcon from '@mui/icons-material/Schedule';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  DashboardOutlined,
  FileOutlined,
  AreaChartOutlined,
  ProfileOutlined,
  ScheduleIcon,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
  id: 'group-applications',
  title: '',
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: "Dashboard",
      title: <FormattedMessage id="dashboard" />,
      type: "item",
      url: "/dashboard",
      icon: AreaChartOutlined,
      target: false,
      rights: ['compare.request', 'compare.admin', 'ngtMCompareOverview'],
    },
    {
      id: 'Overview',
      title: <FormattedMessage id='overview' />,
      type: 'item',
      url: '/overview',
      icon: ProfileOutlined,
      target: false,
      rights: ['compare.login', 'compare.admin', 'ngtMCompare'],
    },
    {
      id: 'Compare Templates',
      title: <FormattedMessage id='compare_templates' />,
      type: 'item',
      url: '/compareTemplates',
      icon: FileOutlined,
      target: false,
      rights: ['compare.template', 'compare.admin', 'ngtMCompareTemplate'],
    },
    {
      id: 'History',
      title: <FormattedMessage id="history" />,
      type: 'item',
      url: '/history',
      icon: ScheduleIcon,
      target: false,
      rights: ['compare.history', 'compare.admin', 'ngtMCompareHistory']
    },
  ],
};

export default applications;
